enum AccountRoleType {
  NONE = "NONE",
  CORPORATION = "CORPORATION",
  OFFICE = "OFFICE",
  STAFF = "STAFF"
}

export default AccountRoleType;
